<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedications">
<h1>Dedications</h1>
<p>To my parents, with love, who taught me how to be kind and forgive anyone who hurts me, they taught me that forgiveness is power and will provide peace to my life, taught me to do the thing that makes me happy; and writing this book really makes me happy. Writing this book is like discharging from my mind all the negative thoughts and the bad feelings that affect me, due to the bad experiences that I went through in the last five years. To my ex, Lina, and because heartbreak isn’t only in love, I dedicate this book to everyone that has given me lessons in life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?2375b120